import React, { useState } from 'react';
import { ContactsTab } from './contacts/ContactsTab';
import { MessagesTab } from './messages/MessagesTab';
import { MessageSquare, Users } from 'lucide-react';

const ContactsModule = () => {
  const [activeTab, setActiveTab] = useState('contacts');

  return (
    <div className="mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center rounded-lg shadow-sm p-3">
        <h1 className="text-2xl font-bold text-gray-900">Chat Module</h1>
        
        {/* Tab Navigation */}
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg w-fit">
          <button
            onClick={() => setActiveTab('contacts')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium transition-all ${
              activeTab === 'contacts'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Users className="w-4 h-4" />
            <span>Contacts</span>
          </button>
          <button
            onClick={() => setActiveTab('messages')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md font-medium transition-all ${
              activeTab === 'messages'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <MessageSquare className="w-4 h-4" />
            <span>Messages</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'contacts' && <ContactsTab setActiveTab={setActiveTab}/>}
      {activeTab === 'messages' && <MessagesTab />}
    </div>
  );
};

export default ContactsModule;